module.exports = __webpack_public_path__ + "img/157.805d2ea3.jpg";